import React, { useState, useEffect, useRef } from "react";
import "./chatbot.css";
import { processQuery, getRandomGreeting } from "../../services/chatbotEngine";

const Chatbot = ({ onSwitchMode }) => {
  const [messages, setMessages] = useState([
    {
      type: "bot",
      content: getRandomGreeting(),
    },
  ]);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = input.trim();

    // Add user message
    setMessages((prev) => [...prev, { type: "user", content: userMessage }]);
    setInput("");
    setIsLoading(true);

    // Simulate small delay for better UX
    setTimeout(() => {
      try {
        const response = processQuery(userMessage);
        setMessages((prev) => [...prev, { type: "bot", content: response }]);
      } catch (error) {
        setMessages((prev) => [
          ...prev,
          {
            type: "bot",
            content:
              "I hit a small issue while processing that. Please try rephrasing your question.",
          },
        ]);
      } finally {
        setIsLoading(false);
        inputRef.current?.focus();
      }
    }, 300);
  };

  return (
    <div className="chatbot-container">
      <div className="chatbot-header">
        <div className="chatbot-title">AI Portfolio Assistant</div>
      </div>

      <div className="chatbot-content">
        {messages.map((msg, idx) => (
          <div key={idx} className={`chat-message chat-${msg.type}`}>
            <div className="message-label">
              {msg.type === "user" ? "You" : "Assistant"}
            </div>
            <div className="message-content">{msg.content}</div>
          </div>
        ))}
        {isLoading && (
          <div className="chat-message chat-bot loading">
            <div className="message-label">Assistant</div>
            <div className="message-content typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      <form onSubmit={handleSendMessage} className="chatbot-input-area">
        <input
          ref={inputRef}
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask me about the projects, skills, experience..."
          className="chatbot-input"
          disabled={isLoading}
          autoFocus
        />
        <button type="submit" className="chatbot-send-btn" disabled={isLoading}>
          {isLoading ? "Thinking..." : "Send"}
        </button>
      </form>
    </div>
  );
};

export default Chatbot;
